
import {
    GET_ASSETS_SUCCESS,
    GET_ASSETS_FAILURE
} from '../constants/actionTypes';

const INITIAL_STATE = {
    data: [],
    error: null
};

export default function contents(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_ASSETS_SUCCESS:
            return { ...state, data: action.payload.data };
        case GET_ASSETS_FAILURE:
            return { ...state, error: action.payload.error }
        default:
            return state;
    }
}
